import env from 'VirtualEnv'

export const siteUrl = env.SITE_URL || 'http://localhost:3000'
export const productImagePath = env.PRODUCT_IMAGE_PATH || ''
